import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { RealtimeActions, RealtimeFacade } from './+state';

@NgModule({
    declarations: [],
    imports: [CommonModule],
    providers: [RealtimeActions, RealtimeFacade],
})
export class RealtimeModule {}
